module.exports = __webpack_public_path__ + "static/media/data.a2fbae8a.jpg";